import React from 'react';
import { Spinner } from 'reactstrap';
import PropsTypes from 'prop-types';
import { noRecord } from 'constants/constants';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
const ListTableRow = (props) => {
  const { isBusy, length, children, col, noDataChildren } = props;
  const themeStatus = useSelector(getThemeColor);
  return (
    <>
      {isBusy ? (
        <tr>
          <td colSpan={col} className="text-center">
            <Spinner style={{ color: `${themeStatus}` }} />
          </td>
        </tr>
      ) : !length ? (
        <tr>
          <td colSpan={12} className="text-center pt-2">
            {noDataChildren || noRecord}
          </td>
        </tr>
      ) : (
        children
      )}
    </>
  );
};

ListTableRow.prototype = {
  isBusy: PropsTypes.bool,
  length: PropsTypes.number.isRequired,
  children: PropsTypes.any.isRequired,
  col: PropsTypes.number.isRequired,
  noDataChildren: PropsTypes.any,
};

export default ListTableRow;
